import { BaseError, type BaseErrorParameters } from './base';

export class MfaRateLimitedError extends BaseError {
  constructor({ cause }: Pick<BaseErrorParameters, 'cause'>) {
    super({
      cause,
      code: 'mfa_rate_limited_error',
      docsUrl: null,
      name: 'MfaRateLimitedError',
      shortMessage: 'Rate limited',
    });
  }
}
